import EditorCache from './editorcache';
import { createRoot } from 'react-dom/client';
import { Initializer } from 'Shared/chakra-initialize';
import { TiptapEditor } from './tiptap/tiptap-lazy';
import { getFormParent } from './utils';

const getSubmitHandler = pm => {
   const form = getFormParent(pm);
   return () => {
      const formManager = form.retrieve('FormManager:formManager');
      formManager.submit();
   };
};

function createTiptapHandle(pm, handleModified) {
   const editorId = pm.id;
   const EditorComponent = Initializer(TiptapEditor);

   const root = createRoot(pm);
   root.render(
      <EditorComponent
         editorid={editorId}
         preset="guide_intro"
         text={pm.dataset['text']}
         submitHandler={getSubmitHandler(pm)}
         handleModified={handleModified}
      />
   );
   // We don't actually use the returned editor handle for guide intro.
   // We get the editor handle from EditorCache in guide_intro.jsx getFormValues().
   return true;
}

export function getOrCreateHandle(id, selector, handleModified) {
   const pm = document.getElementById(id);

   const guideIntro = pm.closest(selector);
   const editorId = guideIntro.id;

   const editor = EditorCache.get(editorId);

   if (editor) {
      return editor;
   }

   return createTiptapHandle(pm, handleModified);
}
